import { render } from "./PurchaseOrderMenu.vue?vue&type=template&id=32c2ebe6&scoped=true"
import script from "./PurchaseOrderMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMenu.vue?vue&type=script&lang=js"

import "./PurchaseOrderMenu.vue?vue&type=style&index=0&id=32c2ebe6&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c2ebe6"]])

export default __exports__